import styled from 'styled-components'

export const TextEllipsisThreeLine = styled.p`
  display: block !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 3;
  -moz-line-clamp: 3;
  -ms-line-clamp: 3;
  -o-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -ms-box-orient: vertical;
  -o-box-orient: vertical;
  box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: auto;
  min-height: 38px;
  font-size: 15px;
  margin-bottom: 10px;
  &:hover {
    color: inherit;
  }
`



// WEBPACK FOOTER //
// ./src/styled/textEllipsisThreeLine.js